import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

export default function MenuLink({ href, children, isInternal, ...props }) {
  const attributes = {
    role: "menuitem",
    tabIndex: 0
  };

  if (href === undefined) {
    return (
      <button {...props} {...attributes}>
        {children}
      </button>
    );
  }

  return isInternal ? (
    <Link to={href} {...props} {...attributes}>
      {children}
    </Link>
  ) : (
    <a href={href} {...props} {...attributes}>
      {children}
    </a>
  );
}

MenuLink.propTypes = {
  href: PropTypes.string,
  onClick: PropTypes.func,
  isInternal: PropTypes.bool
};
